// 32ecc37db61fa70464333dd9db4b756d8a985b28|className=CurrencyApi|type=angular|apiName=am|apiEnumKey=AM|operationHash=5595e6228917a34ed79c432644190991b2496763|kind=api-js

import * as i0 from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Api } from '@myre/common-conf';
import {
  DynamicEnvService,
  AngularSdk,
} from '@myre/ui-domain-http';
import { parseOkResponseFromJSON } from '../../../parsers/OkResponse';

import { parseCurrencyFromJSON } from '../../../parsers/Currency';

export class CurrencyApi extends AngularSdk {
  constructor(
    dynamicEnvService,
    httpClient,
  ) {
    super(dynamicEnvService, httpClient);
  }

  /**
   * @tags CurrencyApi
   * @name CurrencyApiGetAllCurrencies
   * @request GET:/currencies
   */
  getAllCurrencies(
    requestOptions = {},
  ) {
    return this._request(
      {
        path: `/currencies`,
        method: 'GET',
        api: Api.AM,
      },
      {
        ...requestOptions,
        parser: data => parseOkResponseFromJSON(data, {
    contentParser: parseCurrencyFromJSON,
    isContentArray: true,
  }),
      },
    );
  }

  static ɵfac = function CurrencyApi_Factory(t) { return new (t || CurrencyApi)(i0.inject(DynamicEnvService), i0.inject(HttpClient)); };
  static ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({ token: CurrencyApi, factory: CurrencyApi.ɵfac, providedIn: 'root' });
}
